import { Reducer } from 'redux';
import { ActionType } from '../constants/ActionType';
import { DocumentAction } from '../actions';
import TreeModel from 'tree-model';
import { FolderTree } from '@quick/client';
import { DOCUMENTS_ROOT_PATH, toPath } from '../../utils/DocumentUtils';

export interface DocumentState {
  /**
   * The root of the community's folder tree.
   */
  folderTree: TreeModel.Node<FolderTree>;
  /**
   * The folder tree node the user is browsing.
   */
  activeFolderNode: TreeModel.Node<FolderTree>;
}

export const folderTreeModel = new TreeModel({
  childrenPropertyName: 'subFolders',
  modelComparatorFn(left: FolderTree, right: FolderTree) {
    // Sort files by ascending name.
    return left.name.localeCompare(right.name) > 0;
  },
});

const initialState = (): DocumentState => {
  const root = folderTreeModel.parse({
    name: 'Documents',
    path: DOCUMENTS_ROOT_PATH,
    subFolders: [],
  });
  return {
    folderTree: root,
    activeFolderNode: root,
  };
};

export const Document: Reducer<DocumentState> = (
  state: DocumentState = initialState(),
  action: DocumentAction
): DocumentState => {
  switch (action.type) {
    case ActionType.SET_FOLDER_TREE_ROOT: {
      const folderTree = folderTreeModel.parse(action.folderTreeRoot);
      return {
        ...state,
        folderTree,
      };
    }
    case ActionType.SET_FOLDER_TREE_ACTIVE_PATH:
      if (!state.folderTree) {
        return state;
      }
      const activeFolderNode =
        state.folderTree.first((node) => {
          return toPath(node) === action.path;
        }) ?? state.folderTree;
      return {
        ...state,
        activeFolderNode,
      };
    case ActionType.SIGNOUT:
      return initialState();
    default:
      return state;
  }
};
